import { VideoPlayer } from './VideoPlayer';
import { MobileView } from './MobileView';
import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';
import { useScreenOrientation } from '../../hooks/useScreenOrientation';
import { useCitrusView } from '../../contexts/CitrusViewContext';
import { useUser } from '../../contexts/UserContext';
import { NoDataMessage } from '../../components/NoDataMessage';
import { LoopOutlined } from '@material-ui/icons';

interface Props {
  isPortrait: boolean;
}

export const PlayerExperience = ({ isPortrait }: Props) => {
  const { isMobile, connectedUser, disconnect, rebooting } = useCitrusView();
  const { email } = useUser();
  const [closeMobileView, setCloseMobileView] = useState(false);
  const isLandscape = useScreenOrientation('landscape');

  useEffect(() => {
    const disconnectCv = () => {
      if (connectedUser === email) disconnect();
    };
    const disconnectCvOnWindowClose = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      disconnectCv();
    };

    window.addEventListener('beforeunload', disconnectCvOnWindowClose);
    return () => {
      window.removeEventListener('beforeunload', disconnectCvOnWindowClose);
      disconnectCv();
    };
  }, []);

  useEffect(() => {
    if (isLandscape && closeMobileView) setCloseMobileView(false);
  }, [isLandscape]);

  if (connectedUser === undefined) return null;

  if (rebooting)
    return (
      <div className="my-16">
        <NoDataMessage
          icon={
            <LoopOutlined
              className="animate-spin ease-in-out durration-500 rotate-180"
              fontSize="large"
            />
          }
          title="CITRUS View Rebooting"
          subTitle="The encoder is currently rebooting. You can connect again shortly."
        />
      </div>
    );

  if (!isMobile || closeMobileView || (!closeMobileView && isPortrait))
    return <VideoPlayer />;

  return createPortal(
    <MobileView onCloseView={() => setCloseMobileView(true)}>
      <VideoPlayer autoPlay />
    </MobileView>,
    document.getElementById('cv-portal-out') ?? document.body
  );
};
